var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldAllsetra(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 107,
    viewBox: "0 0 80 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4067_89766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9986 107L31.7332 103.763C20.4262 99.3356 10.846 91.6713 4.02905 81.5963C1.39394 77.6998 0 73.1521 0 68.4429V12.628H1.09114C13.6093 12.628 25.8083 9.0626 36.3706 2.31764L40.0014 0L43.6321 2.31764C54.1917 9.0626 66.3907 12.628 78.9116 12.628H80.0027V68.4429C80.0027 73.1521 78.6088 77.6998 75.9737 81.5963C69.1568 91.6713 59.5792 99.3384 48.2695 103.763L40.0041 107H39.9986ZM2.18229 14.8088V68.4429C2.18229 72.7115 3.44529 76.8351 5.8349 80.3677C12.4009 90.076 21.6319 97.4613 32.527 101.724L40.0014 104.65L47.4757 101.724C58.3708 97.4585 67.6019 90.0733 74.1678 80.3677C76.5574 76.8351 77.8204 72.7115 77.8204 68.4429V14.8088C65.2695 14.6063 53.0651 10.937 42.4619 4.16464L40.0041 2.59401L37.5463 4.16464C26.9376 10.937 14.7332 14.6063 2.18229 14.8088Z",
    fill: "#212B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7156 46.4843H43.3786L42.0283 60.5433H36.3653L37.7156 46.4843ZM27.3742 38.0784L24.4009 68.952H35.5578L41.7692 63.3043L41.2263 68.952H52.4106L55.373 38.0784H27.3715H27.3742Z",
    fill: "#212B33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4067_89766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 107,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAllsetra);
export default __webpack_public_path__ + "static/media/Shield-Allsetra.d847b994f26d026611fe5973d4bdfd74.svg";
export { ForwardRef as ReactComponent };